import axios from 'axios';
import _ from 'lodash';
import {useEffect, useState} from 'react';
import useSWR from 'swr';

import {getDataEndpointUrl, getDataTypeEndpointUrl, makeSafeForUrl} from './data-url-helpers';

async function getEntityLink(entityTypeIdOrName, entityId, availableFormatters, toPage) {
    const detailFormatter = _.find(availableFormatters, {formatterType: 'detail'});
    const editFormatter = _.find(availableFormatters, {formatterType: 'edit'});

    const dataTypeName = await (async () => {
        // check if we have the data type id by trying to parse it as a number
        const id = parseInt(entityTypeIdOrName, 10);
        if (!(typeof id === 'number' && !Number.isNaN(id))) return entityTypeIdOrName;

        // we have the id instead, load the data type name
        const dataTypeEndpoint = getDataTypeEndpointUrl(entityTypeIdOrName);
        return await axios
            .get(dataTypeEndpoint)
            .then((response) => response.data)
            .then((data) => data.dataTypeName);
    })();

    const safeUrlEntityName = makeSafeForUrl(dataTypeName);

    if (toPage) {
        return `/data/${safeUrlEntityName}/${toPage}/${entityId}`;
    }
    if (detailFormatter) {
        return `/data/${safeUrlEntityName}/detail/${entityId}`;
    }
    if (editFormatter) {
        return `/data/${safeUrlEntityName}/edit/${entityId}`;
    }
}

export function useEntityActions(entityTypeIdOrName, entityId) {
    const [entityLink, setEntityLink] = useState();
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    const {data, isLoading, mutate} = useSWR(`${endpoint}/${entityId}/actions`, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    useEffect(() => {
        const load = async () => {
            const link = await getEntityLink(entityTypeIdOrName, entityId, data.availableFormatters);
            setEntityLink(link);
        };

        if (data) load();
    }, [data]);

    if (data === undefined) return {loading: true};

    return {
        actions: data.customActions,
        availableFormatters: data.availableFormatters,
        canDelete: data.canDelete,
        canEdit: data.canEdit,
        loading: isLoading,
        entityLink,
        reload: mutate,
    };
}

export async function loadEntityActions(entityTypeIdOrName, entityId, toPage) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    const response = await axios.get(`${endpoint}/${entityId}/actions`);
    return {
        actions: response.data.customActions,
        availableFormatters: response.data.availableFormatters,
        canDelete: response.data.canDelete,
        canEdit: response.data.canEdit,
        entityLink: await getEntityLink(entityTypeIdOrName, entityId, response.data.availableFormatters, toPage),
    };
}

export default useEntityActions;
